import React, { useEffect, useState } from 'react';
export function UrgencySection() {
  const [spotsLeft, setSpotsLeft] = useState(147);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpotsLeft(prev => {
        if (prev <= 50) return prev;
        return prev - 1;
      });
    }, 45000);
    return () => clearInterval(interval);
  }, []);
  return <section className="w-full py-20 px-4 border-t" style={{
    backgroundColor: '#f8fafc',
    borderColor: '#e2e8f0'
  }} data-id="element-579">
      <div className="max-w-3xl mx-auto" data-id="element-580">
        <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-10 text-center" style={{
        color: '#0f172a'
      }} data-id="element-581">
          ¿Por Qué Ahora?
        </h2>

        <div className="overflow-x-auto mb-10" data-id="element-582">
          <table className="w-full border-collapse rounded-md overflow-hidden" data-id="element-583">
            <thead data-id="element-584">
              <tr style={{
              backgroundColor: '#0f172a'
            }} data-id="element-585">
                <th className="text-left p-4 text-sm font-bold" style={{
                color: '#16a34a'
              }} data-id="element-586">
                  Si Descargas HOY
                </th>
                <th className="text-left p-4 text-sm font-bold" style={{
                color: '#dc2626'
              }} data-id="element-587">
                  Si Esperas 12 Meses
                </th>
              </tr>
            </thead>
            <tbody data-id="element-588">
              <tr className="bg-white border-b" style={{
              borderColor: '#e2e8f0'
            }} data-id="element-589">
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-590">
                  ✅ Ventaja de ser el primero en tu nicho
                </td>
                <td className="p-4" style={{
                color: '#64748b'
              }} data-id="element-591">
                  ❌ 10X más competencia
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#f8fafc'
            }} className="border-b" data-id="element-592">
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-593">
                  ✅ Clientes más fáciles de conseguir
                </td>
                <td className="p-4" style={{
                color: '#64748b'
              }} data-id="element-594">
                  ❌ Clientes más exigentes
                </td>
              </tr>
              <tr className="bg-white border-b" style={{
              borderColor: '#e2e8f0'
            }} data-id="element-595">
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-596">
                  ✅ Tarifas más altas
                </td>
                <td className="p-4" style={{
                color: '#64748b'
              }} data-id="element-597">
                  ❌ Tarifas comprimidas
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#f8fafc'
            }} data-id="element-598">
                <td className="p-4 font-bold" style={{
                color: '#0f172a'
              }} data-id="element-599">
                  ✅ Inversión de solo $49.999
                </td>
                <td className="p-4 font-bold" style={{
                color: '#dc2626'
              }} data-id="element-600">
                  ❌ El precio sube a $99.999
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="text-lg text-center mb-6" style={{
        color: '#64748b'
      }} data-id="element-601">
          Este precio de{' '}
          <strong style={{
          color: '#0f172a'
        }} data-id="element-602">
            $49.999
          </strong>{' '}
          termina a las 300 descargas. Luego sube a{' '}
          <strong style={{
          color: '#dc2626'
        }} data-id="element-603">
            $99.999
          </strong>{' '}
          permanentemente.
        </p>

        {/* Counter */}
        
      </div>
    </section>;
}